import { createSlice } from "@reduxjs/toolkit";

const toastSlice = createSlice({
  name: "tastSlicer",
  initialState: {
    isOpen: false,
    text: "",
    color: "",
  },
  reducers: {
    openErrorToast(state, action) {
      state.isOpen = true;
      state.text = action.payload;
      state.color = "error";
    },
    openSuccessToast(state, action) {
      state.isOpen = true;
      state.text = action.payload;
      state.color = "success";
    },
    closeToast(state, action) {
      state.isOpen = false;
      state.text = "";
      state.color = "";
    },
  },
});

export const { openErrorToast, openSuccessToast, closeToast } =
  toastSlice.actions;
export const toastReducer = toastSlice.reducer;
